module.exports = __webpack_public_path__ + "static/media/kite_surfing_1024.219f9c47.jpg";